<template>
  <div class="iOS-prompt" v-show="showIOSPrompt">
    <div class="iOS-prompt__message-wrap">
      <p class="iOS-prompt__message">
        Claim even quicker next time. Tap
        <img class="iOS-prompt__share-icon" :src="shareIcon" alt="Save to home screen" /> and then <strong>Add to Home Screen</strong> for an app-like experience without the download.
      </p>
    </div>
    <div class="iOS-prompt__dismiss-bar">
      <form class="iOS-prompt__close-form" @submit.prevent="togglePrompt">
        <input type="checkbox" id="iOS-prompt__close-checkbox" @change.prevent="dismissIOSPrompt" ref="iOSPromptDismissPermanently">
        <label for="iOS-prompt__close-checkbox" class="label label--iOS-prompt">Do not show this again</label>
        <button type="submit" class="close-iosPrompt">
          <i class="fa fa-times" aria-hidden="true"></i> <span class="visuallyhidden">Dismiss</span></button>
      </form>
    </div>
  </div>
</template>

<script>
import shareIcon from '@/assets/apple-share-icon.svg';

export default {
  name: 'iOSPrompt',
  data() {
    return {
      shareIcon,
      showIOSPrompt: false,
      dismissedPermanently: localStorage.getItem('dismissedPermanently')
        ? localStorage.getItem('dismissedPermanently')
        : false,
    };
  },
  created() {
    const visits = window.photoClaim.visits;
    const isIOS = window.photoClaim.isIOS;
    const iOSPromptViewCount = window.photoClaim.iOSPromptViewCount;
    const isFromHomeScreen = window.photoClaim.isFromHomeScreen;
    const dismissedPermanently = this.dismissedPermanently;

    // Show iOSPrompt if conditions are met
    // -- IOS = true
    // -- isFromHomeScreen = false
    // -- the user is currently viewing the app for the 2nd, 4th, 8th, 12th or 16th time
    // -- has not been dismissed permanently
    // -- error message is not currently showing

    if (
      (visits === 2 || visits % 4 === 0) &&
      isIOS &&
      iOSPromptViewCount <= 4 &&
      !isFromHomeScreen &&
      !dismissedPermanently
    ) {
      this.showIOSPrompt = true;
      window.photoClaim.iOSPromptViewCount += 1;
    }
  },
  methods: {
    dismissIOSPrompt(event) {
      // Set var dismissPermanently to value of checkbox
      const dismissPermanently = this.$refs.iOSPromptDismissPermanently.value === 'on' ? true : false;

      // Hide prompt
      this.showIOSPrompt = false;

      // Set has seen iOSPrompt to true
      window.localStorage.setItem('hasSeenIOSPrompt', true);

      // Increment add to home screen view count
      window.photoClaim.iOSPromptViewCount += 1;

      if (dismissPermanently) {
        console.log('dismissed permanently');
        this.dismissedPermanently = true;
        localStorage.setItem('dismissedPermanently', true);
      }
    },
    togglePrompt() {
      this.showIOSPrompt = !this.showIOSPrompt;
    }
  },
};
</script>

<style scoped lang="scss">

.iOS-prompt {
  font-size: .875rem;
  margin-bottom: 20px;
  position: relative;

  @include theme-gmhba {
    background: var(--color-gmhba-primary);
  }

  @include theme-frank {
    background: var(--color-frank-secondary);
  }
}

.iOS-prompt__message-wrap {
  display: flex;
  padding: 10px 40px 0 10px;
}

.iOS-prompt__dismiss-bar {
  padding: 10px;
}

.iOS-prompt p {
  color: white;
  margin: 0;
  padding: 0;
}

.close-iosPrompt {
  background: transparent;
  border: 0;
  color: white;
  font-size: 1.3rem;
  position: absolute;
  padding-right: 0;
  top: 10px;
  right: 10px;
}

.iOS-prompt__app-icon {
  height: 40px;
  width: 40px;
}

.iOS-prompt__close {
  color: var(--color-gmhba-primary);
  display: block;
}

.label--iOS-prompt {
  color: white;
  text-transform: none;
  font-weight: 500;
  font-size: .8rem;
  line-height: 1.4;
}

.iOS-prompt__share-icon {
  margin: 0 2px -3px;
  width: 15px;
}

</style>



// WEBPACK FOOTER //
// src/components/global/iOSPrompt.vue